import {
  INTERNAL_STATUS_WAITING_PICKUP,
  INTERNAL_STATUS_SHIPMENT_DATA_RECEIVED,
  INTERNAL_STATUS_PICKUP_FAILED,
  INTERNAL_STATUS_PICKED_UP,
  INTERNAL_STATUS_IN_TRANSIT,
  INTERNAL_STATUS_PROCESSING,
  INTERNAL_STATUS_ON_DELIVERY,
  INTERNAL_STATUS_PROBLEMATIC_PROCESSING,
  INTERNAL_STATUS_CUSTOM_MATTER,
  INTERNAL_STATUS_SELF_COLLECT,
  INTERNAL_STATUS_DETAINED,
  INTERNAL_STATUS_LOST,
  INTERNAL_STATUS_RETURN_IN_TRANSIT,
  INTERNAL_STATUS_RETURNED_INITIATED,
  INTERNAL_STATUS_RETURNED,
  INTERNAL_STATUS_DELIVERED,
  INTERNAL_STATUS_COD_AMOUNT_DEPOSITED,
  INTERNAL_STATUS_COD_AMOUNT_REMITTED,
  INTERNAL_STATUS_CLOSED
} from "../../constants/status";

export const COD_AWAITING_HANDOVER_STATUSES = [
  INTERNAL_STATUS_WAITING_PICKUP,
  INTERNAL_STATUS_SHIPMENT_DATA_RECEIVED,
  INTERNAL_STATUS_PICKUP_FAILED,
];

export const COD_PROCESSING_DELIVERY_STATUSES = [
  INTERNAL_STATUS_PICKED_UP,
  INTERNAL_STATUS_IN_TRANSIT,
  INTERNAL_STATUS_PROCESSING,
  INTERNAL_STATUS_ON_DELIVERY,
  INTERNAL_STATUS_CUSTOM_MATTER,
  INTERNAL_STATUS_SELF_COLLECT,
];

export const COD_PROBLEMATIC_STATUSES = [
  INTERNAL_STATUS_DETAINED,
  INTERNAL_STATUS_PROBLEMATIC_PROCESSING,
];

export const COD_RETURNING_STATUSES = [
  INTERNAL_STATUS_RETURN_IN_TRANSIT,
  INTERNAL_STATUS_RETURNED_INITIATED,
];

export const COD_EXCEPTION_STATUSES = [
  INTERNAL_STATUS_RETURNED,
  INTERNAL_STATUS_LOST,
  INTERNAL_STATUS_CLOSED];

export const COD_PENDING_REMITTANCE_STATUSES = [
  INTERNAL_STATUS_DELIVERED,
  INTERNAL_STATUS_COD_AMOUNT_DEPOSITED,
  INTERNAL_STATUS_COD_AMOUNT_REMITTED,
];

export const COD_DASHBOARD_CONFIG = {
  awaitingHandover: {
    title: "AWAITING HANDOVER",
    statuses: COD_AWAITING_HANDOVER_STATUSES,
    statKey: "awaitingHandoverCod",
  },
  processingDelivery: {
    title: "PROCESSING DELIVERY",
    statuses: COD_PROCESSING_DELIVERY_STATUSES,
    statKey: "pendingCod",
  },
  problematic: {
    title: "PROBLEMATIC",
    statuses: COD_PROBLEMATIC_STATUSES,
    statKey: "problematicCod",
  },
  pendingRemittance: {
    title: "PENDING REMITTANCE",
    statuses: COD_PENDING_REMITTANCE_STATUSES,
    statKey: "pendingRemittanceCod",
    isRemittance: false,
  },
  returning: {
    title: "RETURNING",
    statuses: COD_RETURNING_STATUSES,
    statKey: "returningCod",
  },
  exception: {
    title: "EXCEPTION",
    statuses: COD_EXCEPTION_STATUSES,
    statKey: "refundedCod",
  },
  remitted: {
    title: "REMITTED",
    statuses: "",
    statKey: "remittedCod",
    isRemittance: true,
  },
};

export const COD_STATUSES = [
  ...COD_AWAITING_HANDOVER_STATUSES,
  ...COD_PROCESSING_DELIVERY_STATUSES,
  ...COD_PROBLEMATIC_STATUSES,
  ...COD_RETURNING_STATUSES,
  ...COD_EXCEPTION_STATUSES,
  ...COD_PENDING_REMITTANCE_STATUSES,
];

export const COD_STAT_CARDS = Object.entries(COD_DASHBOARD_CONFIG).map(
  ([key, config]) => ({
    key,
    title: config.title,
    statKey: config.statKey,
  })
);

export const getCodDashboardFilter = (key) => {
  const config = COD_DASHBOARD_CONFIG[key];

  if (!config) {
    return {
      isRemittance: null,
      completeDelivered: null,
      isCodRefunded: null,
      internalStatus: null,
      notInternalStatus: null,
    };
  }

  return {
    isRemittance:
      typeof config.isRemittance === "boolean" ? config.isRemittance : null,
    completeDelivered: null,
    isCodRefunded: null,
    internalStatus: config.statuses,
    notInternalStatus: null,
  };
};